import { render, staticRenderFns } from "./DashboardInstitutionBranchMap.vue?vue&type=template&id=f2931bf6&scoped=true"
import script from "./DashboardInstitutionBranchMap.vue?vue&type=script&lang=js"
export * from "./DashboardInstitutionBranchMap.vue?vue&type=script&lang=js"
import style0 from "./DashboardInstitutionBranchMap.vue?vue&type=style&index=0&id=f2931bf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2931bf6",
  null
  
)

export default component.exports